/**
 * Generated from ch5_p06.fla
 */
export function ch5_p06(this: Ich5_p06) {
	const butterfly = this.butterfly;
	if (!butterfly[0] && butterfly.elementFactory) {
		butterfly[0] = butterfly.elementFactory(0,undefined);
	}
	if (butterfly[0]) {
		ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly1.call(butterfly[0] as Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly1);
		butterfly[0].x = 1096.5;
		butterfly[0].y = 389.25;
		butterfly[0].width = 381.00;
		butterfly[0].height = 455.50;
		butterfly[0].alpha = 1;
		if (butterfly[0].onLayout) butterfly[0].onLayout();
	}
	if (!butterfly[1] && butterfly.elementFactory) {
		butterfly[1] = butterfly.elementFactory(1,undefined);
	}
	if (butterfly[1]) {
		ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly2.call(butterfly[1] as Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly2);
		butterfly[1].x = 1096.5;
		butterfly[1].y = 393.75;
		butterfly[1].width = 407.00;
		butterfly[1].height = 446.50;
		butterfly[1].alpha = 1;
		if (butterfly[1].onLayout) butterfly[1].onLayout();
	}
	if (!butterfly[2] && butterfly.elementFactory) {
		butterfly[2] = butterfly.elementFactory(2,undefined);
	}
	if (butterfly[2]) {
		ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly3.call(butterfly[2] as Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly3);
		butterfly[2].x = 1102.25;
		butterfly[2].y = 393.75;
		butterfly[2].width = 433.50;
		butterfly[2].height = 446.50;
		butterfly[2].alpha = 1;
		if (butterfly[2].onLayout) butterfly[2].onLayout();
	}
	if (!butterfly[3] && butterfly.elementFactory) {
		butterfly[3] = butterfly.elementFactory(3,undefined);
	}
	if (butterfly[3]) {
		ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly4.call(butterfly[3] as Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly4);
		butterfly[3].x = 1101.5;
		butterfly[3].y = 393.75;
		butterfly[3].width = 463.00;
		butterfly[3].height = 446.50;
		butterfly[3].alpha = 1;
		if (butterfly[3].onLayout) butterfly[3].onLayout();
	}
	const bg = this.bg;
	ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyHorse = this.hollyHorse;
	ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_hollyhorse.call(this.hollyHorse);
	hollyHorse.x = 667.5;
	hollyHorse.y = 393.25;
	hollyHorse.width = 367.00;
	hollyHorse.height = 717.50;
	hollyHorse.alpha = 1.00;
	if (hollyHorse.onLayout) hollyHorse.onLayout();
	const frameRight = this.frameRight;
	ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframerlijnes.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 399;
	linesRight.width = 228.00;
	linesRight.height = 738.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 373.75;
	linesLeft.width = 57.00;
	linesLeft.height = 747.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_bg(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p06_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly1(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p06_butterfly1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly2(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p06_butterfly2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly3(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p06_butterfly3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly4(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly4) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p06_butterfly4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_hollyhorse(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_hollyhorse) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p06_hollyhorse", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeRframe(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframerlijnes(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframerlijnes) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlijnes", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeLframe(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframellines(this: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p06Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p06Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p06Sprite extends Ich5_p06Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p06Text extends Ich5_p06Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p06Polygon extends Array<number> {
}
interface Ich5_p06 {
	readonly butterfly: Ich5_p06Array<Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly1|Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly2|Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly3|Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly4>;
	readonly bg: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_bg;
	readonly hollyHorse: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_hollyhorse;
	readonly frameRight: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeRframe;
	readonly linesRight: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframerlijnes;
	readonly frameLeft: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeLframe;
	readonly linesLeft: Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframellines;
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_bg extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly1 extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly2 extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly3 extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_butterfly4 extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_hollyhorse extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeRframe extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframerlijnes extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframeLframe extends Ich5_p06Sprite {
}
interface Ich5_p06_hh_ch5_72dpi_p06psdAssetch5_p06_wcframellines extends Ich5_p06Sprite {
}
